export default __webpack_public_path__ + "static/media/ANISHA ARORA.d5bd7824.jpg";